function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.2 69.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.01,1.07c-.58.72-1.01,9.24-1.04,20.25-.04,14.92-.4,19.96-1.67,23.49C.14,50.79-.68,59.68.62,63.02c1.34,3.45,5.01,5.84,10.01,6.51,3.29.44,4.54.06,7.51-2.32,5.78-4.61,6.26-6.98,3.22-16.09-1.8-5.39-2.61-9.97-2.62-14.8-.02-8.12-1.81-16.49-5.6-26.15C9.46.8,7.22-1.71,5.01,1.07",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.26,11.87c3.17,8.24,5.46,18.92,5.49,25.6l.02,5.14-3.29-.74c-1.81-.41-4.23-.39-5.38.03-2.07.77-2.08.67-1.81-18.9.15-10.82.33-19.9.39-20.17.24-1.04,2.15,2.72,4.59,9.05",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,44.69c2.02.8,5.66,9.94,5.66,14.24,0,1.82-1.14,3.68-3.54,5.79-4.11,3.61-4.15,3.61-9.5,1.47-2.76-1.1-3.9-2.09-3.53-3.05.3-.78.15-1.18-.34-.88-1.61.99-2.21-4.59-1.07-10.05,1.53-7.38,5.91-10.05,12.32-7.53",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.7c0cbcc49b2fdc0c9ca273bf4cf950f4.svg";
export { ForwardRef as ReactComponent };